import axios from 'axios';
import baseUrl from '../BaseUrl';

/**
 * Build a URLSearchParams object from a filter state, encoding repeated params
 * correctly for platform and status and turning eventTypes[] into a CSV.
 */
const buildQuery = (filter = {}) => {
  const p = new URLSearchParams();
  if (filter.page) p.set('page', String(filter.page));
  if (filter.limit) p.set('limit', String(filter.limit));
  if (filter.startDate) p.set('startDate', filter.startDate);
  if (filter.endDate) p.set('endDate', filter.endDate);
  (filter.platform || []).forEach((v) => p.append('platform', String(v)));
  (filter.status || []).forEach((v) => p.append('status', v));
  if (filter.eventTypes?.length) p.set('eventTypes', filter.eventTypes.join(','));
  return p.toString();
};

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const fetchList = async (filter, token) => {
  const qs = buildQuery(filter);
  const res = await axios.get(
    `${baseUrl}/admin/api/webhook-activity/list?${qs}`,
    authHeaders(token)
  );
  return res.data;
};

export const fetchAggregates = async (filter, token) => {
  // Aggregates share filter shape but do NOT use page/limit
  // eslint-disable-next-line no-unused-vars
  const { page, limit, ...aggFilter } = filter || {};
  const qs = buildQuery(aggFilter);
  const res = await axios.get(
    `${baseUrl}/admin/api/webhook-activity/aggregates?${qs}`,
    authHeaders(token)
  );
  return res.data;
};
